import React from "react";
import {
  faFacebook,
  faTelegram,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const fb = <FontAwesomeIcon icon={faFacebook} />;
const telegram = <FontAwesomeIcon icon={faTelegram} />;
const linkedIn = <FontAwesomeIcon icon={faLinkedin} />;
const github = <FontAwesomeIcon icon={faGithub} />;

const logo = [
  {
    icons: fb,
    path: "https://www.facebook.com/trelaxz",
    title: "Facebook",
  },
  {
    icons: telegram,
    path: "https://t.me/phatreak",
    title: "Telegram",
  },
  {
    icons: linkedIn,
    path: "https://www.linkedin.com/in/ry-pheak-tra-2075b0315",
    title: "LinkedIn",
  },
  {
    icons: github,
    path: "https://github.com/Trahapii",
    title: "GitHub",
  },
];

export { logo };
